import Marionette from 'backbone.marionette';
import Navigator from 'app';
import L from 'leaflet';
import mapItemviewTmpl from '../templates/map_itemview.tpl';
import house from '../../../../data/ga_house.json';
import senate from '../../../../data/ga_senate.json';
export default Marionette.ItemView.extend({
  template: mapItemviewTmpl,
  onShow: function () {
    var geocoder = new google.maps.Geocoder(),
      autocomplete;
    var cartodbAttribution = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="https://carto.com/attribution/">CartoDB</a>';
    var map = L.map('map', {
      scrollWheelZoom: false,
      minZoom: 3
    });
    var $map = $('#map'),
      mapX = $map.offset().left,
      mapY = $map.offset().top;
    var isMobile = window.innerWidth < 600 ? true : false;
    var mapWidth = $('#members-tabs').width(),
      mapHeight = $map.height();
    var $tooltip = $('#maptip'),
      tipContent = $('#maptip > .info-content');
    $('#map-tip-close-button').click(function (e) {
      $tooltip.hide();
    });

    // Style the shape boundaries
    var style = {
      opacity: 1,
      color: 'gray',
      weight: .5,
      fillColor: '#FD8D3C'
    };
    map.createPane('labels');
    map.getPane('labels').style.zIndex = 650;
    map.getPane('labels').style.pointerEvents = 'none';

    // Zoom out a bit more on smaller screens
    if (isMobile) {
      map.setView({
        lat: 32,
        lng: -83.72
      }, 5.5);
    } else {
      map.setView({
        lat: 32.8,
        lng: -83.32
      }, 7);
    }

    // Put labels on top of basemap
    L.tileLayer('//{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}.png', {
      pane: 'labels',
      attribution: cartodbAttribution
    }).addTo(map);

    // Create base map
    L.tileLayer('//{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
      attribution: cartodbAttribution
    }).addTo(map);

    // Load both geojson layers and default to senate
    var senLayer = L.geoJson(senate, {
      onEachFeature: onEachFeature,
      style: style
    });
    var houseLayer = L.geoJson(house, {
      onEachFeature: onEachFeature,
      style: style
    });
    senLayer.addTo(map);

    // Show layer depending on which button is clicked
    var $mapRadioBtns = $("#choose-map").find('button');
    $mapRadioBtns.on('click', function (e) {
      // Extract id, therefore knowing which layer to show
      var toShow = e.target.id.split('-')[0];
      $mapRadioBtns.removeClass('active');
      $(this).addClass('active');
      if (toShow === 'house' && !map.hasLayer(houseLayer)) {
        map.removeLayer(senLayer);
        houseLayer.addTo(map);
      } else {
        map.removeLayer(houseLayer);
        senLayer.addTo(map);
      }
    });

    // Find lat/long of address entered by user, so we can locate their legislators
    function codeAddress(address) {
      geocoder.geocode({
        'address': address
      }, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          var location = results[0].geometry.location;
          // This is to handle when the user enters their address and does not click on the map. In this situation, we won't have an event object to pass because there is no event that fired from the map. So we are simply passing a dummy value i.e. 1. you can look at the getLegislatorsByLocation function and showPopup function to see how this is handled

          getLegislatorsByLocation(1, location.lat(), location.lng());
        } else {
          showError();
        }
      });
    }
    initInput();
    function initInput() {
      var options = {
        types: ['address']
      }; //placeIdOnly is so we don't get charged for getting all place details. Supposedly you can do this by specifying fields but I can't get that to work with autocomplete. The above   -EMD
      var input = document.getElementById('members-map-address');
      //autocomplete is billed by session now so no worries about keystrokes, plus I tried initializing after some typing and it didn't work (see commit f0b44d2 ln 107)
      //I also tried setting placeIdOnly to true (free to get) then using geocoder (cheaper than places) to get location (see commit f0b44d2) to reduce cost, but actually autocomplete is included with basic data and costs the same by itself and geocoding is an additional cost, so it's cheapest to just get basic data with autocomplete. MAKE SURE YOU DO autocomplete.setFields() and get only basic data fields unless you really need more, otherwise it gets expesive fast. See https://mapsplatformtransition.withgoogle.com/calculator
      //get_place documentation https://developers.google.com/maps/documentation/javascript/places-autocomplete#get_place_information
      //more helpful links about how not to get charged for calling getDetails when selecting a results from Autocompelte https://stackoverflow.com/questions/52328108/google-map-auto-complete-call-without-place-details-request
      //https://stackoverflow.com/questions/51047063/how-to-use-skubasic-with-google-places-api
      autocomplete = new google.maps.places.Autocomplete(input, options);
      autocomplete.setFields(['geometry']);
      //autocomplete.bindTo('bounds', maps[0]); //not sure why this wasn't working but throws an error
      autocomplete.addListener('place_changed', onPlaceChanged);
      function onPlaceChanged() {
        // If there's a coordinate obtained, go to that.
        try {
          var loc = autocomplete.getPlace().geometry.location;
          // This is to handle when the user enters their address and does not click on the map. In this situation, we won't have an event object to pass because there is no event that fired from the map. So we are simply passing a dummy value i.e. 1. you can look at the getLegislatorsByLocation function and showPopup function to see how this is handled
          getLegislatorsByLocation(1, loc.lat(), loc.lng());
        } catch (err) {
          console.warn('Place error: ', err);
          showError();
        }
      }
    } // initInput()

    function onEachFeature(feature, layer) {
      layer.on({
        mouseover: highlightFeature,
        mouseout: resetHighlight,
        click: zoomToFeature
      });
    }
    function highlightFeature(e) {
      var layer = e.target;
      layer.setStyle({
        weight: 3,
        color: '#666',
        dashArray: ''
      });
      if (!L.Browser.ie && !L.Browser.opera) {
        layer.bringToFront();
      }
    }
    function zoomToFeature(e) {
      var lat = e.latlng.lat,
        lng = e.latlng.lng;

      // Get the legislators and then zoom to that district
      getLegislatorsByLocation(e, lat, lng);
      map.fitBounds(e.target.getBounds());
    }
    function resetHighlight(e) {
      var layer = e.target;
      layer.setStyle(style);
    }
    function getLegislatorsByLocation(e, lat, lng) {
      var url = 'https://openstates.org/api/v1/legislators/geo/?apikey=d92f1bfc-395f-4c1f-9245-4cb92e3cdb7d&lat=' + lat + '&long=' + lng;
      $.ajax({
        url: url,
        dataType: 'json',
        success: function (data) {
          if (data && data.length > 0 && data[0].state === 'ga') {
            showPopup(data, e, lat, lng);
          } else {
            showError();
          }
        },
        error: function (err) {
          console.error(err.responseText);
          showError();
        }
      });
    }
    function showPopup(data, e, lat, lng) {
      var e = e || 1; // Default to 1 if there is no event object.

      var rep_info = parseMemberInfo(data, 0);
      var sen_info = parseMemberInfo(data, 1);
      var member_id_regexp = /Member=(\d+)/;
      var rep_id = member_id_regexp.exec(rep_info.url)[1];
      var sen_id = member_id_regexp.exec(sen_info.url)[1];
      var _html = '<div class="popup-content">';
      _html += '<div class="p-member-info">' + '<p><strong>Ga. Senate District ' + sen_info.district + '</strong></p>' + '<a href="../#members/' + sen_id + '">' + '<img src="icon_' + sen_id + '.jpg" alt="Sen. ' + sen_info.fullname + '" />' + 'Sen. ' + sen_info.fullname + ' (' + sen_info.party + ')' + '</a>' + '</div>';
      _html += '<div class="p-member-info">' + '<p><strong>Ga. House District ' + rep_info.district + '</strong></p>' + '<a href="../#members/' + rep_id + '">' + '<img src="icon_' + rep_id + '.jpg" class="' + rep_info.party + '" alt="Rep. ' + rep_info.fullname + '" />' + 'Rep. ' + rep_info.fullname + ' (' + rep_info.party + ')' + '</a>' + '</div>';
      _html += '</div>';

      // If there is an event object, place the tooltip near where the user clicked
      if (e !== 1) {
        var xy = calculateTipXY(e.originalEvent.clientX, e.originalEvent.clientY);
        $tooltip.css({
          left: xy[0],
          top: xy[1]
        });
      } else {
        // if there is no event object, pan to the lat/lng geocoded by the geocoder and place the tooltip to the top left of the map
        map.flyTo([lat, lng], 11);
        $tooltip.css({
          left: mapX,
          top: mapY
        }).show();
      }
      tipContent.empty().append(_html);
      $tooltip.show();
    }
    function showError() {
      var error_html = '<p class="tip-error">Sorry, we were unable to find your legislators. Please try entering a new address or clicking on a district again.<p>';
      tipContent.empty().append(error_html);
      $tooltip.css({
        left: mapX,
        top: mapY
      }).show();
    }
    function parseMemberInfo(data, i) {
      var m_info = {
        fullname: data[i].full_name,
        party: data[i].party,
        photo_url: data[i].photo_url,
        district: data[i].district,
        url: data[i].url
      };
      return m_info;
    }
    function calculateTipXY(clientX, clientY) {
      var x, y;

      // On small screens, just stick the tooltip to the left of the map
      if (isMobile) {
        return [mapX, mapY];
      }
      // Otherwise, calculate where on the map the click has happened and push it to the left or top if it is too far right or too far below
      if (clientX > mapWidth - 200) {
        x = mapWidth - 210;
      } else {
        x = clientX + 20;
      }
      if (clientY > mapHeight / 2) {
        y = clientY - 200;
      } else {
        y = clientY;
      }
      return [x, y];
    }
  }
});